import { useState } from 'react'
import { useLanguage } from '@/hooks/useLanguage'

const LANGUAGE_WHITE_LIST_FOR_CGU = ['en', 'en-US', 'en-SA', 'ar-SA']

/** The CGU dialog is shown before creating a patient, except in the languages listed above. */
export function shouldShowCgu(language: string) {
  return !LANGUAGE_WHITE_LIST_FOR_CGU.includes(language)
}

type DialogState = 'add-by-vitale-card' | 'carte-vitale-infos' | 'add-by-external-identity' | 'cgu' | 'none'

export function useDialogState() {
  const language = useLanguage()
  const [dialogState, setDialogState] = useState<DialogState>(shouldShowCgu(language) ? 'cgu' : 'none')

  const closeDialog = () => setDialogState('none')

  return {
    closeDialog,
    dialogState,
    setDialogState,
  }
}
